import { useBoundStore } from '.';

export const useGlobalModalsSlice = useBoundStore.use.globalModalsSlice;
export const useAchievementsNotificationModalsSlice =
  useBoundStore.use.achievementsNotificationModalsSlice;
export const useEntitySlice = useBoundStore.use.entitySlice;
export const useEventCreateSlice = useBoundStore.use.eventCreateSlice;
export const useSetupFundSlice = useBoundStore.use.setupFundSlice;

export const useProfileSlice = useBoundStore.use.profileSlice;
export const useSelectedUserConfigSlice = useBoundStore.use.selectedUserConfigSlice;
export const useLayoutSlice = useBoundStore.use.layoutSlice;
export const useCommunicationsShellSlice = useBoundStore.use.communicationsShellSlice;

/**
 * The fund setup slice as it is right now, outside React's render cycle. A handler that writes
 * derived state has to read what earlier writes in the same tick already stored; the rendered
 * snapshot from `useSetupFundSlice` still holds the values from before them.
 */
export const getSetupFundState = () => useBoundStore.getState().setupFundSlice;
